Monitoring.Models.SocialContents ||= {}

String::endsWith = (s) ->
  this[this.length-s.length...] == s

class Monitoring.Models.SocialContents.WhatsappMessageContent

  constructor: (json) ->
    @json = json
    @parent = null

  getJson: ->
    @json

  getParent: ->
    @parent

  setParent: (parent) ->
    @parent = parent

  getGroupType: ->
    'whatsapp'

  getType: ->
    'whatsapp'

  getSubType: ->
    'whatsapp_message'

  getPrivacy: ->
    'private'

  getWhatsappType: ->
    @json.whatsappMessage.messageType

  getWhatsappMsgId: ->
    @json.whatsappMessage.id

  getContentId: ->
    @json.whatsappMessage.id

  isBrandContent: ->
    @json.isBrandContent || false

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    false

  getAuthorId: ->
    if @json.whatsappMessage.from
      @json.whatsappMessage.from
    else
      ''

  getAuthorName: ->
    result = '+' + @getAuthorId()
    if @json.whatsappMessage.profileName != ''
      result = result  + '  ' + @json.whatsappMessage.profileName
    result

  getAuthorUsername: ->
    @getAuthorName()

  getAvatar: ->
    if !@isBrandContent()
      window.image_path('user-default-img-copia' + '.png')
    else
      window.image_path('wa-logo.png')

  getChannelText: ->
    ''

  getCreatedAt: ->
    @json.created_at

  getMessageStatus: ->
    @json.whatsappMessage.status

  getErrorInfo: ->
    if @json.errorInfo
      @json.errorInfo
    else
      ''

  getMainText: ->
    ""

  getEnrichedMainText: ->
    text = @getMainText()
    text = text.replace(/\*([^\*]*)\*/g, '<b>$1</b>')
    text = text.replace(/_([^_]*)_/g, '<i>$1</i>')
    text.replace(/\~([^\~]*)\~/g, '<s>$1</s>')

  getTitle: ->
    ""

  getLink: ->
    ""

  hasParent: ->
    @json.parent?

  hasQuickReplies: ->
    false

  hasAttachments: ->
    false

  getAttachments: (att_type) ->
    []

  hasShares: ->
    false

  getShares: ->
    []

